import axios from 'axios';
import { getToken } from './authService';

const API_BASE = process.env.REACT_APP_API_BASE_URL || '/api';
const client = axios.create({ baseURL: API_BASE });
client.interceptors.request.use((config) => {
  const token = getToken();
  if (token) { config.headers = config.headers || {}; config.headers.Authorization = `Bearer ${token}`; }
  return config;
});

export async function getReputationSeries() {
  const { data } = await client.get('/reputation/series');
  return data;
}
